module.exports = __webpack_public_path__ + "static/office_outing_2v2-299381fa77e7b9697da300fb5e4dab73.jpg";